import { ApiResponse, User } from '@restaurant/types';
import http from '~/http';

const LOGIN_URL = '/api/v1/login';

type LoginResponse = ApiResponse<{
  token: string;
  user: User;
}>;

export const fetchLogin = (data: { username: string; pin: string }) => {
  return http.post<LoginResponse>(LOGIN_URL, data);
};
